function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M0 0h20l10 9.75V40H0z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#343333",
  fillRule: "nonzero",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("g", {
  mask: "url(#b)",
  fill: "#FFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15 32a9 9 0 110-18 9 9 0 010 18zm0-15.75a6.75 6.75 0 100 13.5 6.75 6.75 0 000-13.5zm-1.125 9h2.25v2.25h-2.25v-2.25zm0-6.75h2.25v5.625h-2.25V18.5z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#898989",
  fillRule: "nonzero",
  mask: "url(#b)",
  d: "M20 0h10v10H20z"
}));

var SvgGithubIssue = function SvgGithubIssue(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 40,
    viewBox: "0 0 30 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGithubIssue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/github_issue.9e497937.svg";
export { ForwardRef as ReactComponent };